/** World size in pixels (matches server simulation). */
export const WORLD_W = 800;
export const WORLD_H = 600;
export const ROOM_NAME_ARENA = "arena";
/** First team to bank this many cores wins. */
export const WIN_BANKED_CORES = 12;
export const TICK_RATE = 20;
export const TICK_MS = 1000 / TICK_RATE;
export const PLAYER_RADIUS = 14;
export const PROJECTILE_RADIUS = 5;
export const PICKUP_RADIUS = 10;
/** Seconds standing in vault to deposit carried cores. */
export const VAULT_DEPOSIT_TIME = 0.6;
export const RESPAWN_SECONDS = 3;
//# sourceMappingURL=constants.js.map